<template>

    <div>
        <settingsNav></settingsNav>

        <v-container>

            <v-layout row wrap>

                <v-flex xs12 sm12 mb-2>

                    <v-btn class="secondary white--text" @click.stop="openContactFunctionDialog(null)">
                        New Contact Function
                        <v-icon class="white--text" right>add</v-icon>
                    </v-btn>

                </v-flex>

            </v-layout>

            <v-layout row wrap>

                <v-flex xs12 sm12>
                    <v-layout row>
                        <v-flex xs12>

                            <v-card>
                                <v-card-title>
                                    <v-card-title class="headline">
                                        Contact Functions
                                    </v-card-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                            v-model="search"
                                            append-icon="search"
                                            label="Search"
                                            single-line
                                            hide-details
                                            clearable
                                    ></v-text-field>
                                </v-card-title>

                                <v-data-table
                                        :headers="headers"
                                        :items="getContactFunctions"
                                        :pagination.sync="pagination"
                                        :total-items=total
                                        class="elevation-0"
                                        :loading="loading"
                                        :rows-per-page-items="rowsPageItems"
                                >

                                    <template slot="headerCell" slot-scope="props">
                                        <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                            <span>
                                          {{ props.header.text }}
                                        </span>
                                        </v-tooltip>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                      <v-touch tag="tr"
                                               @doubletap="openContactFunctionDialog(props.item.id)"
                                               @dblclick="openContactFunctionDialog(props.item.id)">
                                            <td>{{ props.item.id }}</td>
                                            <td class="text-xs-left">{{ props.item.name }}</td>
                                            <td class="text-xs-left">{{ props.item.description }}</td>
                                      </v-touch>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-flex>

                    </v-layout>

                    <addContactFunctionDialog></addContactFunctionDialog>

                </v-flex>
            </v-layout>

        </v-container>
    </div>

</template>

<script>
    // Types
    import {
        Settings,
        ContactFunctionsSettings
    } from '../../../store/namespace-helper'

    import addContactFunctionDialog from '../ContactFunctions/AddContactFunctionDialog.vue'
    import settingsNav from '../../Shared/SettingsNav.vue'
    import {stateHelperMixin} from '../../../mixins/stateHelperMixin'
    import _ from 'lodash'

    export default {
      name: 'contact-functions',
      components: {
        addContactFunctionDialog,
        settingsNav
      },
      mixins: [stateHelperMixin],
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'ContactFunction-ID', value: 'id'},
                    {text: 'Contact Function Name', value: 'name'},
                    {text: 'Description', value: 'description'}
          ],
          pagination: {},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [10, 25, 50, 100, 250]
        }
      },
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadContactFunctions()
      },
      methods: {
        openContactFunctionDialog (val) {
          if (val !== null) {
            let item = this.getContactFunctions.find(x => x.id === val)
            this.$store.dispatch(ContactFunctionsSettings.actions.setSelectedContactFunction, item)
          }
          this.$store.dispatch(ContactFunctionsSettings.actions.openCloseNewContactFunctionDialog)
        },
        loadContactFunctions: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          this.$store.dispatch(ContactFunctionsSettings.actions.loadContactFunctions, query)
        },
        throttledLoadContactFunctions: _.debounce(function () {
          this.loadContactFunctions()
        }, 450)
      },
      computed: {
        getContactFunctions () {
          console.log('ContactFunctionSettings.getters.contactFunctions: ' + ContactFunctionsSettings.getters.contactFunctions)
          this.total = this.$store.getters[ContactFunctionsSettings.getters.contactFunctions].total
          return this.$store.getters[ContactFunctionsSettings.getters.contactFunctions].data
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadContactFunctions()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadContactFunctions()
          },
          deep: true
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Settings/ContactFunctions/ContactFunctions.vue